module.exports = __webpack_public_path__ + "img/3.cbb456f6.jpg";